import type { ChartSeries, ChartValueFormat } from '@fruitful/types';
import { Platform } from 'react-native';
import { BarChart } from 'react-native-gifted-charts';
import type { ColorTokenKey } from 'smoothie';

import {
    BAR_INITIAL_SPACING,
    CHART_HEIGHT,
    CHART_Y_SECTIONS,
    formatAxisValue,
    getAxisMax,
    getBarLayout,
    getYAxisLabelWidth,
    toChartValue,
    X_AXIS_LABEL_LINES,
} from './chartUtils';

export const VerticalBarChart = ({
    series,
    valueFormat,
    chartWidth,
    getColor,
}: {
    series: ChartSeries;
    valueFormat: ChartValueFormat;
    chartWidth: number;
    getColor: (token: ColorTokenKey) => string;
}) => {
    const yAxisLabelWidth = getYAxisLabelWidth(valueFormat);
    const { barWidth, spacing } = getBarLayout(
        chartWidth,
        series.points.length,
        yAxisLabelWidth,
    );
    const data = series.points.slice(0, 7).map((point) => ({
        value: toChartValue(point.value, valueFormat),
        label: point.label,
        frontColor: getColor('$leaf'),
        opacity: 0.85,
        barBorderRadius: 8,
    }));
    const maxValue = getAxisMax(
        data.map((point) => point.value),
        CHART_Y_SECTIONS,
    );

    return (
        <BarChart
            data={data}
            width={chartWidth}
            height={CHART_HEIGHT}
            disablePress
            {...(Platform.OS === 'web' ? { parentWidth: chartWidth } : {})}
            barWidth={barWidth}
            spacing={spacing}
            initialSpacing={BAR_INITIAL_SPACING}
            maxValue={maxValue}
            noOfSections={CHART_Y_SECTIONS}
            yAxisThickness={0}
            yAxisLabelWidth={yAxisLabelWidth}
            xAxisColor={getColor('$gray400')}
            rulesColor={getColor('$gray300')}
            yAxisTextStyle={{ color: getColor('$gray1000'), fontSize: 12 }}
            xAxisLabelTextStyle={{
                color: getColor('$gray1000'),
                fontSize: 12,
                textAlign: 'center',
            }}
            xAxisTextNumberOfLines={X_AXIS_LABEL_LINES}
            formatYLabel={(label) =>
                formatAxisValue(Number(label), valueFormat)
            }
        />
    );
};
